import { Component, OnInit, Input } from '@angular/core';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';
import { EDeliveryService } from '../../services/edelivery.service';
import { Context } from '../../models/context.model';


@Component({
  selector: 'e-delivery',
  templateUrl: './e-delivery.component.html'
})
export class EdeliveryComponent implements OnInit {

  edeliveryPreferencesTitle: any = EdeliveryLabels.EDELIVERY_PREFERENCES_TITLE;

  constructor(private eDeliveryService: EDeliveryService, private translate: PershingTranslationService) {
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-newedelivery', 'node_modules/@pershing/edc-newedelivery/lib');
    }
    // eDeliveryService.setContextData('3CR', 'JAYANTQA', '1', '2', 'EMS');
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
